<template>
        <div class="form-create-account__automations-automationX tooltip-container"
             v-bind:class="{'form-create-account__automations-automationX--before' : isBeforeEvent, 'form-create-account__automations-automationX--after' : !isBeforeEvent, 'form-create-account__automations-automationX--selected' : automation.selected}"
             v-on:click="toggleSelection"
             v-on:mouseenter="showTooltip = true"
             v-on:mouseleave="showTooltip = false"
        >
            <div class="form-create-account__automations-automationX-name">
                <div class="form-create-account__automations-automationX-icons">
                    <template v-if="isTypeGuestForm">
                        <i class="fas fa-envelope" aria-hidden="true"></i>
                        +
                        <i class="fab fa-wpforms" aria-hidden="true"></i>
                    </template>
                    <template v-if="isTypeEmail">
                        <i class="fas fa-envelope" aria-hidden="true"></i>
                    </template>
                    <template v-if="isTypeSMS">
                        <i class="fas fa-sms" aria-hidden="true"></i>
                    </template>
                    <template v-if="isTypeWhatsApp">
                        <i class="fas fa-comments" aria-hidden="true"></i>
                    </template>
                    <template v-if="isTypeToDo">
                        <i class="fas fa-list" aria-hidden="true"></i>
                    </template>
                </div>
                {{automation.name}}
            </div>
            <div v-if="isTypeGuestForm"
                 v-on:click.stop="showForm"
                 class="form-create-account__automations-automationX-preview">
                <i class="fas fa-eye"></i>
            </div>
            <input type="checkbox" v-model="automation.selected">
    <!--        <div class="form-create-account__automations-automationX-days"-->
    <!--             v-bind:class="{'form-create-account__automations-automationX-days&#45;&#45;after' : !isBeforeEvent, 'form-create-account__automations-automationX-days&#45;&#45;before' : isBeforeEvent}">-->
    <!--            <i class="far fa-clock"></i>-->
    <!--            {{daysString}}-->
    <!--        </div>-->
<!--        </div>-->
        <tooltip v-bind:visible="showTooltip && !showFormPreview"
                 v-bind:position="'bottom'"
                 v-bind:text="getTooltipText"></tooltip>

        <form-preview v-if="showFormPreview" v-bind:automation="automation"></form-preview>
    </div>
</template>

<script>
    import FormPreview from './FormPreview'
    import Tooltip from '../../components/Tooltip'

    import {automationsMixin} from '../../mixins/AutomationsMixin'

    export default {
        name: "AutomationSummary.vue",
        // components: {},
        components: {FormPreview, Tooltip},
        mixins: [automationsMixin],
        props: {
            automation: Object
        },
        data: function () {
            return {
                showTooltip: false,
                showFormPreview: false
            }
        },
        computed: {
            isBeforeEvent: function() {
                return this.automation &&
                    this.automation.when.strategy !== 'immediate' &&
                    (this.automation.when.numberOfDaysFrom < 0 || (this.automation.when.numberOfDaysFrom === 0 && this.isAutomationTimeOfDayLessThanHour(this.automation, 10)));
            },
            isTypeGuestForm: function () {
                let automationType = String(this.automation.type);
                if (automationType === 'guest-form-with-questions' || automationType === 'send-omni-channel-guest-form-with-questions') {
                    return true;
                }
                return false;
            },
            isTypeEmail: function () {
                if (String(this.automation.type) === 'send-email') {
                    return true;
                }
                return false;
            },
            isTypeSMS: function () {
                if (String(this.automation.type) === 'send-sms') {
                    return true;
                }
                return false;
            },
            isTypeWhatsApp: function () {
                if (String(this.automation.type) === 'send-whatsapp') {
                    return true;
                }
                return false;
            },
            isTypeToDo: function () {
                if (String(this.automation.type) === 'to-do') {
                    return true;
                }
                return false;
            },
            daysString: function() {
                switch (this.automation.when.strategy) {
                    case 'immediate':
                        return "Immediately"
                    case 'before-or-after-arrival':
                        if (this.automation.when.numberOfDaysFrom < 0) {
                            return Math.abs(this.automation.when.numberOfDaysFrom) + " day" + (this.automation.when.numberOfDaysFrom === -1 ? "" : "s") + " before check-in";
                        } else if (this.automation.when.numberOfDaysFrom > 0) {
                            return this.automation.when.numberOfDaysFrom + " day" + (this.automation.when.numberOfDaysFrom === 1 ? "" : "s") + " after check-in";
                        } else {
                            return "On the day of check-in";
                        }
                    case 'before-or-after-departure':
                        if (this.automation.when.numberOfDaysFrom < 0) {
                            return Math.abs(this.automation.when.numberOfDaysFrom) + " day" + (this.automation.when.numberOfDaysFrom === -1 ? "" : "s") + " before check-out";
                        } else if (this.automation.when.numberOfDaysFrom > 0) {
                            return this.automation.when.numberOfDaysFrom + " day" + (this.automation.when.numberOfDaysFrom === 1 ? "" : "s") + " after check-out";
                        } else {
                            return "On the day of check-out";
                        }
                }
                return ""
            },
            getTooltipText: function() {
                return this.automation.reasonToUse;
                // switch (this.automation.type) {
                //     case 'send-omni-channel-guest-form-with-questions':
                //         return "Email the guest asking them to fill in a form";
                //     case 'send-email':
                //         return "Email the guest";
                //     case 'send-sms':
                //         return "SMS the guest";
                //     case 'guest-form-with-questions':
                //         return "Create an arrival form for the guest to fill in at your front desk";
                //     case 'todo':
                //     default:
                //         return "Create a Todo task";
                // }
            }
        },
        methods: {
            showForm: function() {
                this.showFormPreview = true;
                this.showTooltip = false;
            },
            hideForm: function() {
                this.showFormPreview = false;
            },
            toggleSelection: function() {
                if (!this.showFormPreview) {
                    this.$root.$emit("create-account-toggle-automation", this.automation.reference);
                }
            }
        },
        mounted() {
            this.$root.$on('finished-previewing-form', this.hideForm);
        },
        beforeDestroy() {
            this.$root.$off('finished-previewing-form', this.hideForm);
        }
    }

</script>

<style lang="scss" scoped>
    @import "../../styles/pages/create-account";
</style>